export interface Notification {
  notificationRecipientsId: string,
  title: string,
  message: string,
  isRead: boolean,
  creationDate: Date,
  documentSource: DocumentSource,
  sourceSystem: keyof typeof SourceSystemEnum,
  path: string,
  count?: number
}

export type DocumentSource = 'Task Management' | 'Sales Order' | 'Conversation';

export enum SourceSystemEnum {
  RenewalQuoteRequest = 'Renewals',
  SCOUT = 'SCOUT',
  RENEWALS = 'Renewals',
  POBacklog = 'PO Backlog',
  ShipPreparation = 'Ship Preparation',
  RMARequest = 'RMA'
}